import { render } from "./blogDetail.vue?vue&type=template&id=0d3054ae"
import script from "./blogDetail.vue?vue&type=script&lang=js"
export * from "./blogDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__